export const loginPoints = [
    'SAAASPASS_ON_SLACK',
    'SAASPASS_CONNECTOR',
    'SAASPASS_EXTENSION',
    'SAASPASS_MOBILE_APP',
    'SAASPASS_WEB',
    'SAAASPASS_HANGOUTS',
];

export const loginPointLabel = loginPoint => ({
    SAAASPASS_ON_SLACK: 'sp-login-point.saaaspass-on-slack',
    SAASPASS_CONNECTOR: 'sp-login-point.saaspass-connector',
    SAASPASS_EXTENSION: 'sp-login-point.saaspass-extension',
    SAASPASS_MOBILE_APP: 'sp-login-point.saaspass-mobile-app',
    SAASPASS_WEB: 'sp-login-point.saaspass-web',
    SAAASPASS_HANGOUTS: 'sp-login-point.saaaspass-hangouts',
})[loginPoint];



// WEBPACK FOOTER //
// ./src/portal/components/sp-login-point/sp-login-point.enum.js